import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white"></Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-With oversight of diverse segments including digital banking, SMEs, and affluent
                clients, how do you tailor Mashreq’s retail strategy to deliver personalized and
                profitable customer experiences across such varied needs?
              </strong>
            </h5>

            <h5 className="text-white">
              Our retail strategy starts with a clear understanding of the needs and expectations of
              each segment.
              <br />
              <br />
              For the digitally savvy individuals, speed, convenience, and seamless mobile access
              are essential. We have invested heavily in platforms such as Mashreq NEO to provide
              intuitive, secure, and always-available services that integrate naturally into
              customers’ daily lives.
              <br />
              <br />
              For SMEs, the priority is different. Business owners need banking solutions that can
              save time, simplify operations, and support growth. Mashreq NEOBiz delivers these
              capabilities with integrated payroll, accounting software connections, trade finance,
              and cash flow tools designed to work in real time.
              <br />
              <br />
              Affluent clients, on the other hand, place greater emphasis on advisory support,
              wealth planning, and relationship-based services, which we deliver through dedicated
              teams and a curated set of investment and savings products.
              <br />
              <br />
              What unites these different approaches is our commitment to personalization,
              data-driven decision-making, and constant innovation. We use analytics to identify
              patterns in behavior and preferences, allowing us to tailor offerings to each segment
              while maintaining efficiency and scalability. Customer feedback, gathered through
              surveys, app reviews, and direct interactions, feeds back into product design,
              ensuring that our solutions remain relevant and trusted.
              <br />
              <br />
              This combination of human insight, technology, and agile delivery enables us to serve
              very different customer groups without losing focus on profitability and long-term
              relationships.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- You’ve led retail banking transformations at major institutions globally. What
                sets Mashreq’s digital-first approach apart in a competitive and fast-evolving
                regional market?
              </strong>
            </h5>
            <h5 className="text-white">
              At Mashreq, our approach starts with a clear vision: to position ourselves as more
              than a bank; to become a facilitator of financial services that customers can access
              wherever and whenever they need them. This means moving away from the idea that
              customers must come to a branch or even log in to a single app. Instead, our aim is to
              be present across platforms they already use, whether that is a travel booking site,
              an e-commerce platform, or a social media application. We design our services so that
              they can be integrated into multiple channels, ensuring a consistent and frictionless
              experience across all touchpoints.
              <br />
              <br />
              The advantage we have is the ability to combine the governance, security, and
              resilience of a well-established bank with the agility and innovation mindset often
              associated with fintechs. This allows us to deliver new propositions quickly, test
              them in-market, and refine them based on real-time feedback.
              <br />
              <br />
              In the Middle East, this is particularly important because customers here compare
              their banking experiences not only to other banks but also to leading global tech
              companies. Our digital-first strategy ensures we keep pace with these expectations by
              prioritizing simplicity, speed, and personal relevance. This is supported by strong
              partnerships with fintechs and technology providers, giving us access to new
              capabilities without slowing delivery.
            </h5>
            <br />
            <h5 className="text-white">
              <strong>
                Q-Given your background in CRM, analytics, and marketing, how do you leverage data
                to deepen customer engagement and loyalty across Mashreq’s platforms like Neo and
                NEOBiz?
              </strong>
            </h5>
            <h5 className="text-white">
              Data enables us to understand our customers at a level that was not possible a decade
              ago. We capture and analyze information from a wide range of sources: transactional
              data, digital interactions, call center transcripts, surveys, and even sentiment from
              social media. This allows us to move from broad segmentation to what we call
              hyper-personalization, where products, services, and communications are tailored to
              the individual.
              <br />
              <br />
              For Mashreq NEO customers, this might mean designing a dashboard that highlights
              budgeting tools for someone focused on savings, or market updates for an active
              investor. For NEOBiz, it could involve creating predictive cash flow forecasts,
              automated invoice tracking, and customized lending recommendations based on historical
              patterns and real-time needs. We also use data to anticipate life events or financial
              requirements, enabling us to reach out with relevant offers or guidance before
              customers even ask.
              <br />
              <br />
              Loyalty grows when customers feel understood and supported. By applying analytics and
              machine learning, we can ensure that every interaction adds value – whether digital or
              human.
              <br />
              <br />
              This data-driven approach not only improves satisfaction and retention but also helps
              us build deeper, longer-term relationships grounded in trust.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Retail banking is no longer just transactional—it’s experiential. How are you
                evolving Mashreq’s value proposition to meet rising customer expectations around
                convenience, personalization, and trust?
              </strong>
            </h5>
            <h5 className="text-white">
              Modern customers expect banking to be as seamless and intuitive as their favorite
              consumer apps, yet also expect it to be safe, transparent, and responsive. Meeting
              these expectations requires us to blend advanced technology with a human-centric
              approach. We invest in AI and machine learning to personalize the digital experience,
              making interactions more relevant and timely. This could mean tailored financial
              advice, customized alerts, or predictive product recommendations that anticipate needs
              before they arise.
              <br />
              <br />
              At the same time, we ensure that customers who need human support can access it
              quickly and without barriers. Our teams are trained and empowered to act in the
              customer’s best interest, moving beyond scripts to offer meaningful guidance. Trust is
              reinforced through strong security protocols, clear pricing, and open communication.
              <br />
              <br />
              We also see financial wellbeing as part of our value proposition. This includes
              offering tools for budgeting, saving, and investing, as well as promoting responsible
              lending. By focusing equally on convenience, personalization, and trust, we ensure
              that our services are not just functional but also aligned with customers’ broader
              goals and values.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-With your experience at global banks like BBVA and Standard Chartered, how do you
                see the future of retail banking taking shape in the MENAT region, and what role
                will innovation and partnerships play in that journey?
              </strong>
            </h5>
            <h5 className="text-white">
              The MENAT region is one of the most exciting markets for retail banking. It combines
              high digital adoption with a young, tech-savvy population, supportive regulators, and
              fast-growing economies. At the same time, there remain large unbanked and underbanked
              segments, creating opportunities for digital solutions that can expand access to
              financial services.
              <br />
              <br />
              The future of retail banking here will be defined by deeper integration of banking
              into customers’ daily lives through models like embedded finance and
              Banking-as-a-Service. These approaches will make financial services available within
              non-banking platforms, from online shopping to ride-hailing apps, removing friction
              and increasing convenience.
              <br />
              <br />
              Partnerships will be essential in this journey. Fintechs bring specialized
              technologies and innovative user experiences, while telcos offer extensive reach into
              underserved communities. Collaborating with these partners allows us to scale faster,
              diversify offerings, and tap into new customer segments. Innovation will go beyond
              product features to include business model transformation, advanced analytics, and
              real-time personalization.
              <br />
              <br />
              Banks that can balance trust and regulatory strength with adaptability, agility and
              openness to collaboration will be the ones that shape the region’s retail banking
              future.
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
